import React from 'react';
import styled from '@emotion/styled';
import { Helmet } from 'react-helmet';

import ArticleWrap from '../../components/organisms/articleWrap';
import ArticleBody from '../../components/organisms/articleBody';
import ColumnDetailAside from '../../components/organisms/columnDetail/columnDetailAside';
import ArticleHeader from '../../components/molecules/articleHeader';
import ArticleSection from '../../components/molecules/articleSection';
import ArticleImage from '../../components/atoms/articleImage';
import TextBlock from '../../components/molecules/textBlock';
import Text from '../../components/atoms/text';
import Caption from '../../components/atoms/caption';

const Container = styled.div`
`;

const ColumnDetail = (props) => {
  return(
    <Container>
      <Helmet
          title="洗口液で口内トラブルケア！口臭対策だけじゃないその実力とは？ | お口の健康コラム | モンダミン 公式サイト | アース製薬"
          meta={[
              { name: 'description', content: '口臭対策やお口の不快感解消も大事な役目ですが、洗口液には『お口の健康を守る』というメリットがあります。洗口液を使うメリットについてご紹介します。' },
              { name: 'keywords', content: 'マウスウォッシュ,洗口液,液体ハミガキ,液体歯磨き,モンダミン,もんだみん,mondahmin,口臭,歯肉炎,口臭ケア,むし歯予防,オーラルケア,アース製薬' }
          ]}
        >
        <body data-block-header="true" />
      </Helmet>
      <ArticleWrap>
        <ArticleBody>
          <ArticleHeader sub={<>洗口液で口内トラブルケア！</>} title={<>口臭対策だけじゃない<br />その実力とは？</>} filename={'column/05/img-01.jpg'}>
            口臭対策やお口の不快感解消も大事な役目ですが、洗口液には『お口の健康を守る』というメリットがあります。
          </ArticleHeader>
          <ArticleSection heading={<>洗口液のメリットって何だろう？</>}>
            <TextBlock>
              <Text>洗口液を使用している多くの方が求める機能として、「口臭を予防すること*」と「口内がすっきりすること、ネバツキが取れること*」があげられますが、皆さんはどのような効果を期待していますか？<br />口臭対策やお口の不快感解消も大事な役目ですが、洗口液には『お口の健康を守る』というメリットがあります。さっそく、洗口液のはたらきについて見ていきましょう。</Text>
              <Caption>＊アース製薬調べ。『洗口液に関するアンケート』に基づく。</Caption>
            </TextBlock>
          </ArticleSection>
          <ArticleSection heading={<>「口内トラブルケア」が洗口液の大事な役目</>}>
            <TextBlock>
              <Text>口臭、むし歯、歯肉炎……お口の中では様々なトラブルが起こります。その原因となるのが歯垢（プラーク）です。歯垢はお口の中にある食べカスなどのよごれを栄養源にして細菌が増えたもので、いわば“細菌のかたまり”です。白くネバネバしていて歯の表面に強固に付着するため、水で口をすすぐだけでは十分に取り除くことはできません。歯磨きで取り除く必要がありますが、歯と歯の隙間、歯周ポケットには磨き残しが発生しやすく、これが様々な口内トラブルの原因となってしまいます。</Text>
              <ArticleImage filename={'column/05/img-02.jpg'}></ArticleImage>
              <Text>口内トラブルを防ぐポイントの1つは、歯垢が増える原因となる食べカスなどのよごれをしっかりと除去すること。日頃の歯磨きに加えて、フロスや歯間ブラシ、洗口液などを併用して磨き残し対策を行いましょう。洗口液はすすぐだけで洗浄効果を発揮するので、外出先、旅行先、忙しくて歯磨きができない時など、いつでも手軽に使えて便利です。商品によって洗浄力も異なるため、洗浄力が高く、よごれをしっかり落としてくれるものがおすすめです。<br />また、歯垢は“細菌のかたまり”ですから、殺菌成分を配合した洗口液を使って細菌の増殖を抑制するのも効果的です。殺菌成分配合の洗口液を使った後は水でお口をすすがない方が、殺菌成分の効果が続きやすくなります。</Text>
            </TextBlock>
          </ArticleSection>
          <ArticleSection heading={<>お口をすみずみまで清潔にして口内トラブルを防ごう！</>}>
            <TextBlock>
              <ArticleImage filename={'column/05/img-03.jpg'}></ArticleImage>
              <Text>お口の中を清潔に保つことは、多くの人が気になる口臭ケアはもちろん、むし歯や歯周病などの口内トラブルを防ぐためにとても重要です。歯磨きだけでなく洗口液なども使ったオーラルケアを日頃から行って、爽やかで健康なお口をキープしましょう！</Text>
            </TextBlock>
          </ArticleSection>
        </ArticleBody>
      </ArticleWrap>
      <ColumnDetailAside></ColumnDetailAside>
    </Container>
  );
};
export default ColumnDetail;
